import { useState, useEffect } from "react";
import { Card } from "./Card";
import { LineChart } from "./shared/LineChart";
import { TimeSeries, ChartData } from "@/helpers/chartData";
import { computeChartState } from "@/helpers/chartData";

interface EconomicRiskProps {
  data: TimeSeries[];
  isLoading: boolean;
}

export function EconomicRiskCard({ data, isLoading }: EconomicRiskProps) {
  const [chartData, setChartData] = useState<ChartData[]>([]);
  const [displayedScore, setDisplayedScore] = useState<number | null>(null);

  useEffect(() => {
    const { chartData: transformedData, currentScore } =
      computeChartState(data);

    setChartData(transformedData);
    setDisplayedScore(currentScore);
  }, [data]);

  return (
    <Card>
      <h2 className="text-xl font-semibold mb-4">Economic Risk</h2>

      <div className="mb-6">
        <div className="text-5xl font-bold text-white">{displayedScore}</div>
      </div>

      <div className="w-full h-36 sm:h-48 md:h-56 lg:h-72">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <div className="text-gray-400">Loading chart data...</div>
          </div>
        ) : chartData.length > 0 ? (
          <LineChart data={chartData} color="#ff9966" />
        ) : (
          <div className="flex justify-center items-center h-full">
            <div className="text-gray-400">No chart data available</div>
          </div>
        )}
      </div>
    </Card>
  );
}
